<template>
  <div>
    <p v-if="showLearningFields" class="mb-3">
      Vui lòng chọn thông tin ca thi cho khách hàng:
    </p>
    <div class="form-row mt-2">
      <div class="col-md-6 mb-2">
        {{ showLearningFields ? 'Trung tâm' : 'Trung tâm Test đầu vào' }} <span class="text-danger">(*)</span>
        <ValidationProvider vid="center_test_input_id" name="Trung tâm Test đầu vào" :rules="{required:rules}"
                            v-slot="{ errors,classes }">
          <el-select v-model="testInput.center_id"
                     filterable class="w-100"
                     placeholder="Chọn trung tâm"
                     @change="handleCenterChange()"
                     :disabled="disableInput"
          >
            <el-option
                v-for="item in centersTestInput"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :class="classes"
            >
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select >
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="col-md-6" >
        {{ showLearningFields ? 'Cơ sở' : 'Cơ sở Test đầu vào' }} <span class="text-danger">(*)</span>
        <ValidationProvider vid="branch_id" name="Cơ sở Test đầu vào" :rules="{required:rules}"
                            v-slot="{ errors,classes }">
          <el-select v-model="testInput.branch_id" filterable class="w-100" placeholder="Chọn cơ sở"
                     @change="changeBranchTestInput()" :disabled="disableInput" :loading="loadingBranch">
            <el-option
                v-for="item in branchesTestInput"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :class="classes"
            >
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-row mt-2">
      <div class="col-md-6 mb-2">
        {{ showLearningFields ? 'Hình thức' : 'Hình thức Test đầu vào' }}<span class="text-danger">(*)</span>
        <ValidationProvider vid="center_id" name="Hình thức test đầu vào" :rules="{required:rules}"
                            v-slot="{ errors,classes }">
          <el-select v-model="testInput.hinh_thuc_test_dau_vao"
                     filterable class="w-100"
                     placeholder="Chọn hình thức"
                     @change="changeHinhThucTestInput()"
                     :disabled="disableTypeTest">
            <el-option
                v-for="item in hinhThucTestDauVao"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :class="classes"
            >
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="col-md-6 mb-2" v-if="showMentorLearningFields">
        Giai đoạn học<span class="text-danger">(*)</span>
        <ValidationProvider
            vid="grade_level"
            name="Giai đoạn học"
            :rules="{required:rules}"
            v-slot="{ errors,classes }"
        >
          <el-select
              v-model="testInput.grade_level"
              class="w-100"
              placeholder="Chọn giai đoạn học"
              :class="classes"
              :disabled="disableInput"
              @change="emitTestInput"
          >
            <el-option
                v-for="item in gradeLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="grade_level" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="col-md-6 mb-2">
        {{ showLearningFields ? 'Ngày thi' : 'Thời gian test đầu vào' }}<span class="text-danger">(*)</span>
        <ValidationProvider vid="date_test_input" name="Ngày" :rules="{required:rules}" v-slot="{ errors,classes }">
          <el-date-picker
              v-model="testInput.ngay_hen"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :arrow-control="true"
              :picker-options="pickerOptions"
              @change="changeDataTestInput()"
              :clearable="false"
              :class="classes"
              type="date"
              placeholder="Chọn ngày"
              :disabled="disableInput"
          >
          </el-date-picker>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="col-md-6 mb-2">
        {{ showLearningFields ? 'Giờ thi' : 'Giờ test đầu vào' }}<span class="text-danger">(*)</span>
        <ValidationProvider vid="time_test_input" name="Ca" :rules="{required:rules}" v-slot="{ errors }">
          <el-select filterable class="w-100" v-model="testInput.time" placeholder="Chọn ca" :disabled="disableTime"  @change="changeHour()">
            <el-option-group
                v-for="group in  testHourList"
                :key="group.label"
                :label="group.label"
            >
              <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :disabled=" isDisableHour(item.label)"
                  :value="item">
                <span style="float: left">{{ item.label }}</span>
                <span v-if="isHourTooBad(item.label)"
                      style="float: right; color: #c5a862; font-size: 13px">Nhiều KH lên test ca này!</span>
              </el-option>
            </el-option-group>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
              {{ errors[0] }}
            </div>
          </div>
          <p v-if=" testInput.time && isHourTooBad(testInput.time.value)"
          style="color: #c5a862">
          Khách hàng có thể phải đợi do có nhiều lượt đăng ký ca này!
        </p>
      </ValidationProvider>
    </div>
  </div>
  </div>
</template>

<script>
import {
  BRANCH_LIST,
  CENTER_LIST,
  GET_INPUT_SCHEDULE,
  GET_TESTERT
} from "@/core/services/store/customer/customer.module";
import {TIME_SELECT_OPTION} from "@/core/config/customer/selectTimeOption";
import moment from 'moment-timezone';
import {ONLINE} from "@/core/config/testInput/testInputOption";
import {
    Cambridge_Mentor_ID,
    Mentor_English_Mastery_ID,
    OFFLINE,
    TYPE_SPEAKING_AI,
    TYPES
} from "../../../core/config/testInput/testInputOption";
import {CHECK_SLOT_BY_DAY} from "@/core/services/store/customer/testInput.module";
import {TOEIC} from "../../../core/config/center/centerOption";
import {TIME_SELECT_OPTION_ONLINE} from "../../../core/config/customer/selectTimeOption";
import {
    GRADE_LEVEL_OPTIONS,
    sanitizeGradeLevelPayload
} from "@/core/config/testInput/learningOption";
import { isMasteryCenter } from "@/core/config/testInput/scheduleFieldOption";

export default {
  name: "reschedule-test-input",
  props: {
    checkExist: {
      default: false
    },
    testInputSchedule: {
      default: Object
    },
    checkDisable: {
      default: false
    },
    showTestInput: {
      default: true
    },
    bandType: {
      type: Number,
      default: 1
    },
    showLearningFields: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      optionSelectTime: TIME_SELECT_OPTION,
      optionSelectTimeOnline: TIME_SELECT_OPTION_ONLINE,
      centersTestInput: [],
      branchesTestInput: [],
      hinhThucTestDauVao: TYPES,
      gradeLevelOptions: GRADE_LEVEL_OPTIONS,
      OFFLINE: OFFLINE,
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      testInput: {
        center_id: '',
        branch_id: '',
        hinh_thuc_test_dau_vao: '',
        ngay_hen: '',
        time: null,
        grade_level: ''
      },
      testers: {},
      input_schedule: {},
      dataDisable: {},
      allSlots: {},
      loadingBranch: false,
      slotLoadingInstance: null
    }
  },
  computed: {
    rules() {
      return !(this.checkDisable || !this.showTestInput || this.checkExist);
    },
    disableTime() {
     return false
    },
    disableInput() {
      return false;
    },
    disableTypeTest(){
      return this.testInput.center_id === Cambridge_Mentor_ID
    },
    showMentorLearningFields() {
      return this.showLearningFields && isMasteryCenter(
          this.testInput.center_id,
          Mentor_English_Mastery_ID
      );
    },
    isTypeOffline() {
      if (this.testInput.hinh_thuc_test_dau_vao === OFFLINE) {
        return true;
      }
      return false;
    },
    testHourList(){
      return  this.optionSelectTimeOnline
    }
  },
  methods: {
    error(mess) {
      this.$alert(mess, 'Thông báo', {
        confirmButtonText: 'OK',

      });
    },
    checkSlotByDay() {
      const hasType = this.testInput.hinh_thuc_test_dau_vao !== undefined
        && this.testInput.hinh_thuc_test_dau_vao !== null
        && this.testInput.hinh_thuc_test_dau_vao !== '';
      const hasBranch = !!this.testInput.branch_id;
      const dayMoment = this.testInput.ngay_hen ? moment(this.testInput.ngay_hen) : null;
      if (!hasType || !hasBranch || !dayMoment || !dayMoment.isValid()) {
        return;
      }
      this.closeSlotLoading();
      this.slotLoadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let payload = {
        branch_id: this.testInput.branch_id,
        day: dayMoment.format('YYYY-MM-DD'),
        type: this.testInput.hinh_thuc_test_dau_vao,
        band_type: this.showMentorLearningFields ? 2 : 1
      }
      this.$store.dispatch(CHECK_SLOT_BY_DAY, payload).then((data) => {
        try {
          let Hour = {...data.data}
          Object.keys(data.data || {}).forEach((key,index)=>{
            Hour[key] = Hour[key]?.type??0
          })
          const isOverTime = dayMoment.format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') || (dayMoment.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && moment().format('HH:mm') > '20:00') ;
          this.allSlots = Hour
          let valueHour = Object.values(Hour)
          if (valueHour.filter((e) => e == 0).length == valueHour.length || isOverTime) {
            this.allSlots = {}
            this.error(`${this.testInput.hinh_thuc_test_dau_vao==OFFLINE?'Không có admin test trực tại điểm.':'Ngày chọn đã hết ca trống. Vui lòng chọn ngày khác hoặc liên hệ hotline 0823185694 để đề xuất thêm ca test.'}`);
          }
        } finally {
          this.closeSlotLoading();
        }
      }).catch((res) => {
        this.closeSlotLoading();
        this.error(`${this.testInput.hinh_thuc_test_dau_vao==OFFLINE?'Không có admin test trực tại điểm.':'Ngày chọn đã hết ca trống. Vui lòng chọn ngày khác hoặc liên hệ hotline 0823185694 để đề xuất thêm ca test.'}`);
        this.allSlots = {}
      }).finally(() => {
        if (this.checkExist) {
          // this.allSlots.this.testInput.time = 1
        }
      })
    },
    closeSlotLoading() {
      if (this.slotLoadingInstance) {
        this.slotLoadingInstance.close();
        this.slotLoadingInstance = null;
      }
    },
    isDisableHour(hour) {
      if (!this.allSlots || Object.keys(this.allSlots).length == 0) {
        return true;
      }
      let stringHour = `${this.testInput.ngay_hen} ${hour}`
      return new Date(stringHour).getTime() < new Date().getTime() || (this.allSlots[hour] == 0) || ((this.allSlots[hour] == 2) && this.testInput.hinh_thuc_test_dau_vao == ONLINE)
    },
    isHourTooBad(hour) {
      let stringHour = `${this.testInput.ngay_hen} ${hour}`
      return new Date(stringHour).getTime() > new Date().getTime() && (this.allSlots[hour] == 2) && (this.testInput.hinh_thuc_test_dau_vao == OFFLINE)
    },
    disabledDate(date) {
      let tempDate = new Date();
      let currentDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), 0, 0);
      let nextWeek = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() + (+7 - (tempDate.getDay() == 0 ?7:+tempDate.getDay())));
      return date < currentDate | date > nextWeek;
    },
    async handleCenterChange() {
      this.testInput.branch_id = '';
      this.testInput.grade_level = '';
      if(this.testInput.center_id === Cambridge_Mentor_ID){
        this.testInput.hinh_thuc_test_dau_vao = OFFLINE;
      }
      await this.getBranches();
      this.testInput.time = null
      this.emitTestInput();
      this.changeTime();
    },
    getCenters() {
      this.$store.dispatch(CENTER_LIST)
          .then((response) => {
            if (response.status === 422) {
              this.$notify({
                title: 'Warning',
                message: `Serve đang bận, vui lòng thử lại sau: ${response.data.message}`,
                type: 'warning'
              });
            } else {
              this.centers = response.data;
              this.centersTestInput = response.data.filter(center => center.is_edutalk === 1 && center.id !== TOEIC);
            }
          });
    },
    async getBranches() {
      this.loadingBranch = true ;
      await this.$store.dispatch(BRANCH_LIST, {center_id: this.testInput.center_id})
          .then((response) => {
            if (response.status === 422) {
              this.$notify({
                title: 'Warning',
                message: `Serve đang bận, vui lòng thử lại sau: ${response.data.message}`,
                type: 'warning'
              });
            } else {
              this.branchesTestInput = response.data
            }
          }).finally(()=>{
            this.loadingBranch = false;
          });
    },
    changeHour(){
      this.emitTestInput();
    },
    emitTestInput() {
      const payload = sanitizeGradeLevelPayload({
        payload: this.testInput,
        isMastery: this.showMentorLearningFields
      });
      this.$emit('infoTestInput', payload);
    },
    changeDataTestInput() {
      this.testInput.time = null
      this.emitTestInput();
      this.changeTime();
      this.checkSlotByDay()
    },
    changeBranchTestInput() {
      this.testInput.time = null
      this.emitTestInput();
      this.changeTime();
      this.testInput = {...this.testInput,ngay_hen: null}
    },
    changeHinhThucTestInput() {
      this.testInput.time = null
      this.emitTestInput();
      this.changeTime();
      this.testInput = {...this.testInput,ngay_hen: null}
    },
    dataTestInputSchedule() {
        if (this.$route.query.status == TYPE_SPEAKING_AI)
        {
            return;
        }
      this.testInput.center_id = this.testInputSchedule.center_id
      this.testInput.branch_id = this.testInputSchedule.branch_id
      this.testInput.hinh_thuc_test_dau_vao = this.testInputSchedule.type
      this.testInput.grade_level = this.testInputSchedule.grade_level || ''
      const scheduleDay = moment(this.testInputSchedule.schedule)
      this.testInput.ngay_hen = scheduleDay.isValid() ? scheduleDay.format('YYYY-MM-DD') : ''
      this.testInput.time = scheduleDay.isValid() ? scheduleDay.format('HH:mm') : null
      this.getBranches()
      this.emitTestInput()
    },

    checkDisableTime(value) {
      return value < moment().format("HH:mm");
    },
    changeTime() {
      this.$store.dispatch(GET_TESTERT, {
        time: this.testInput.ngay_hen,
        branch_id: this.testInput.branch_id,
        hinh_thuc_test: this.testInput.hinh_thuc_test_dau_vao
      }).then((response) => {
        this.testers = response;
        this.getInputSchedule();
      });
    },
    getInputSchedule() {
      this.$store.dispatch(GET_INPUT_SCHEDULE, {
        time: this.testInput.ngay_hen,
        branch_id: this.testInput.branch_id,
        hinh_thuc_test: this.testInput.hinh_thuc_test_dau_vao
      }).then((response) => {
        this.input_schedule = response;
        this.checkDisableTimeOption(response)
      });
    },
    checkDisableTimeOption(response) {
      let arrayDisable = [];
      let arr = [];
      if (Object.keys(this.testers).length) {
        Object.values(response).map(function (val, key) {
          TIME_SELECT_OPTION.map(function (value) {
            key = key + 1;
            if (value.live_time == key) {
              Object.values(value.options).map(function (option, keyOp) {
                if (response[key] && !response[key][option.value]) {
                  return true;
                } else {
                  if (!response[key]) {
                    return false;
                  }
                  Object.values(response[key][option.value]).map(function (res, keyRes) {
                    Object.values(value.options).map(function (op, kp) {
                      if (res.end_time > op.value && res.start_time <= op.value) {
                        arrayDisable.push(op.value);
                      }
                    })
                  })
                  arr[key] = arrayDisable;
                }
              })
            }
          });
        });
        this.dataDisable = arr;
        this.test();
      }
    },
    test() {
      for (const val of [1, 2, 3]) {
        if (!this.testers[val]) {
          return false;
        }
        let live = this.testers[val].length;
        if (this.dataDisable[val]) {
          for (const num of this.dataDisable[val]) {
            TIME_SELECT_OPTION.map(function (time) {
              if (time.live_time = live) {
                Object.values(time.options).map(function (op) {
                  if (num == op.value) {
                    op.live_time++;
                    if (live <= op.live_time) {
                      op.live_time = live;
                    }
                  }
                })
              }
            })
          }
        }
      }
    },
    close() {
      this.testInput = {
        center_id: '',
        branch_id: '',
        hinh_thuc_test_dau_vao: '',
        ngay_hen: '',
        time: null,
        grade_level: ''
      }
      this.$emit('close');
    },
    countTesters(arr, live_time) {
      if (!Object.keys(this.testers).length) {
        return false;
      }
      let a = 0
      if (this.testers[live_time]) {
        a = this.testers[live_time].length;
      }
      return arr.live_time >= a;
    }
  },
  async mounted() {
    this.getCenters();
    if (this.checkExist) {
      this.dataTestInputSchedule()
      this.checkSlotByDay()
    } else {
      this.testInput = {
        center_id: '',
        branch_id: '',
        hinh_thuc_test_dau_vao: '',
        ngay_hen: '',
        time: null,
        grade_level: ''
      }
    }
  },
  beforeDestroy() {
    this.closeSlotLoading();
  },
  watch: {
    checkExist(newValue) {
      if (!newValue) {
        this.testInput = {
          center_id: '',
          branch_id: '',
          hinh_thuc_test_dau_vao: '',
          ngay_hen: '',
          time: null,
          grade_level: ''
        }
        document.querySelectorAll(".fv-help-block").forEach(el => el.remove());
      } else {
        this.dataTestInputSchedule()
      }
    }
  }
}
</script>

<style scoped>

</style>
